import { LoggedInConfluenceBlueWaveTemplate } from "../../components/logged-in-confluence-blue-wave-template";

import { useIntl } from "react-intl";

export const LoggedInConfluencePremium = () => {
    const { formatMessage } = useIntl();
    return (
        <LoggedInConfluenceBlueWaveTemplate
            productEditionText={formatMessage({
                id: "WacSignupHeader.cloudPremium",
                defaultMessage: "Cloud Premium"
            })}
        />
    );
};
